export default "__VITE_ASSET__mHZuEor1__"